import styled, { css } from "styled-components";

import Paper from "components/Layout/Paper";

import { COLORS } from "constants/colorScheme";

export const Container = styled.div`
  display: flex;
  flex-direction: row;

  background-color: ${COLORS.WHITE};
  border-radius: 8px;

  :not(:last-child) {
    margin-bottom: 12px;
  }

  ${({ isEditMode }: { isEditMode?: boolean }) =>
    isEditMode &&
    css`
      background-color: ${COLORS.BACKGROUND};
    `}

  ${({ isDragging }: { isDragging?: boolean }) =>
    isDragging &&
    css`
      border: 2px solid ${COLORS.CYAN};
    `}
`;

export const ImageContainer = styled.div`
  min-width: 80px;
  min-height: 80px;

  background-image: url(${({ image }: { image: string }) => image});
  background-size: cover;

  border-radius: 8px;
`;

export const DetailsContainer = styled(Paper)`
  display: flex;
  justify-content: center;

  width: 100%;

  padding: 12px;

  background-color: transparent;
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TitleWrapper = styled.div`
  margin-bottom: 8px;
`;

export const ControlsContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const ControlWrapper = styled.div`
  margin-right: 40px;
`;

export const MenuControlWrapper = styled.div`
  display: flex;
  align-items: center;

  margin-right: 24px;
`;

export const Menu = styled.div`
  display: flex;

  & path,
  & use {
    fill: ${COLORS.BLACK_50};
  }
`;
